var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preferences-propver__content" },
    [
      _c("p", [
        _vm._v(
          " " +
            _vm._s(_vm.$t("Search.propver.Preferences." + _vm.type + ".1")) +
            " "
        ),
      ]),
      _c("p", [
        _vm._v(
          " " +
            _vm._s(_vm.$t("Search.propver.Preferences." + _vm.type + ".2")) +
            " "
        ),
      ]),
      _vm.type === "gaps"
        ? [
            _c("img", { attrs: { width: "100%", src: _vm.imgSrc } }),
            _c("p", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("Search.propver.Preferences." + _vm.type + ".3")
                  ) +
                  " "
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }